import { Injectable, OnInit } from '@angular/core';
import data_settingMAO from '../../assets/json/MaoProject.json';
import { Observable, of, throwError, Subscriber } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { CategoriesVideoComponent } from '../Admin/categories-video/categories-video.component';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true' })
};


const hostGeneral = data_settingMAO.RestApi;
const hostTwilio = data_settingMAO.TwilioServer;
//const hostGeneral = `http://localhost:53356-44444`;
let headers: any = {};
@Injectable({
  providedIn: 'root'
})

export class ApiVideoService implements OnInit {

  postUrlDelete = hostGeneral + '/api/Verticals/DeleteVertical';
  myItemSession: any;
  httpOptions2: any = {};


  constructor(private http: HttpClient) {
    //const headers = { 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': this.myItemSession.Token };  
  }

  ngOnInit(): void {
    this.SetHeadersToken();
  }
  
  //public static get HOME_URL(): string { return "sample/url/"; };
  vertical: Observable<any>;
  baseURL = "https://reqres.in";

  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    //Authorization: localStorage.getItem("accessToken")
  });

  SetHeadersToken() {
    this.myItemSession = localStorage.getItem("SessionMAO");

    if (this.myItemSession == null) {
      let key = "SessionMAO";
      let valueSession = { validate: 'false', name: '' };
      localStorage.setItem(key, JSON.stringify(valueSession));
      this.myItemSession = localStorage.getItem("SessionMAO");
    }

    this.myItemSession = JSON.parse(this.myItemSession);
    this.httpOptions2 = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true' })
    };
    headers = { 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true' };
  }

  SetLocalStorage(NameStorage: string, ValueStorage: object) {
    let key = NameStorage;
    localStorage.setItem(key, JSON.stringify(ValueStorage));
  }

  saveCategory(post: any): Observable<any> {
    this.SetHeadersToken();
    var urlToRequest = hostGeneral + "/api/CategoriesVideo/SaveCategoryVideo";
    return this.http.post<any>(`${hostGeneral}/api/CategoriesVideo/SaveCategoryVideo`, post, { headers });
  }

  saveVideo(post: any): Observable<any> {
    this.SetHeadersToken();
    //var urlToRequest = hostGeneral + "/api/Video/SaveVideo";
    return this.http.post<any>(`${hostGeneral}/api/Video/SaveVideo`, post, { headers });
  }

  deleteVideo(post: any): Observable<any> {
    this.SetHeadersToken();
    let paramsx = new HttpParams().set("id", post.VideoID); //Create new HttpParams
    const options2 = { headers: headers, params: paramsx }
    return this.http.post<any>(`${hostGeneral}/api/Video/DeleteVideo`, post, options2);
  }

  getCategoriesVideoList() {
    this.SetHeadersToken();
    var urlLP = hostGeneral + "/api/CategoriesVideo/GetAllCategoryVideos";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getVideoList() {
    this.SetHeadersToken();
    var urlLP = hostGeneral + "/api/Video/GetAllVideos";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };


  }

}
